/**
 * Used in V1 and V2 Intake
 *
 * This component corresponds to the following templates:
 * views/telemedicine/intakes/payments/new.html.erb
 * views/telemedicine/intakes/v2/payments/new.html.erb
 */

import cardValidator from 'card-validator'
import Cleave from 'cleave.js'

export class CreditCard {
  constructor(el) {
    this.el = el
    this.input = this.el.querySelector('input')

    this.input.addEventListener('input', this.render.bind(this))
    new Cleave(this.input, {
      creditCard: true,
      onCreditCardTypeChanged: function (type) {
        el.setAttribute('data-cctype', type)
      }
    })
    this.render()
  }

  get value() {
    return this.input.value
  }

  get cardNumberValid() {
    return checkCardNumberValid(this.value)
  }

  render() {
    (this.value ? (this.cardNumberValid ? $(this.el).find('input').removeClass('invalid-card') : $(this.el).find('input').addClass('invalid-card')) : '');
    this.el.setAttribute('data-cardvalid', this.cardNumberValid)
  }
}

export function checkCardNumberValid(value) {
  let isCardValid = 0
  let trimmed = value.replace(/\s/g, '')

  if (trimmed === '') {
    return isCardValid
  }

  let cardValid = cardValidator.number(trimmed, { maxLength: 16 })
  if (cardValid.card) {
    const label = document.querySelector('div[class="cc-expiration-error"]');
    label.querySelector('span').classList.add('hidden');
    if (cardValid.isPotentiallyValid && cardValid.isValid) {
      isCardValid = 1
    }
  }
  return isCardValid
}
